const todayBannerConfig = {
    todayBanner: {
        filterLayout: 'TodayBannerFilterDefaultLayout',
        listLayout: 'TodayBannerListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            obs:'desc',    //정렬방식
            obt:'created_at',    //정렬키값
            ty: 'today' // 오늘
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getTodayBanner',
    },
    writeTodayBanner: {
        writeLayouts: ['TodayBannerWriteDefaultLayout'],
        writeFunc: 'createTodayBanner',
        writeApiParamSet: {
            b_type: 'today',
        },
        getCategoryFunc: '',
        parsingData: {
            title: 'b_title',
            link: 'b_link',
            showDate: '',
            showStartDate: 'b_period_first',
            showEndDate: 'b_period_end',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'b_idx',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'bannerImg',
                fileType: 'banner',
                required: true,
                validatorMsg: '이미지를 등록할 수 없습니다.',
            },
        ],
    },
    updateTodayBanner: {
        getFunc: 'getTodayBanner',
        detailApiParamSet: {
            ip: 0,
            ty: 'today',
        },
        writeFunc: 'updateTodayBanner',
        writeLayouts: ['TodayBannerWriteDefaultLayout'],
        writeApiParamSet: {
            b_type: 'today',
        },
        parsingData: {
            title: 'b_title',
            link: 'b_link',
            showDate: '',
            showStartDate: 'b_period_first',
            showEndDate: 'b_period_end',
        },
        keyName: 'b_idx',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '이미지를 등록할 수 없습니다.',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'bannerImg',
                fileType: 'banner',
                required: true,
                validatorMsg: '이미지를 등록할 수 없습니다.',
            },
        ],
        deleteFunc: 'deleteBanner',
        deleteApiParamsSet: {
            b_type: 'today',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
}

export default {
    methods: {
        returnTodayBannerConfig(type) {
            return todayBannerConfig[type];
        },
    },
    filterConfig: {
        ti: { // 제목
            type: 'query',
            classname: 'searchInput',
        }
    },
}
